import { render, staticRenderFns } from "./ToDetail.vue?vue&type=template&id=a525b856&scoped=true"
import script from "./ToDetail.vue?vue&type=script&lang=js"
export * from "./ToDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a525b856",
  null
  
)

export default component.exports